// Convert CommonJS `require` to ES6 `import` if needed. In this case, we're just importing CSS.
import './src/styles/global.css'

// Your existing function, already using ES6 syntax, so it's good to go.
const addScript2 = (url) => {
  const script = document.createElement('script')
  script.src = url
  document.getElementsByTagName('head')[0].appendChild(script)
}

// Exporting onRouteUpdate using ES6 export syntax.
export const onRouteUpdate = ({ location }) => {
  addScript2('//scripts.iconnode.com/62300.js')
}

// Exporting shouldUpdateScroll using ES6 export syntax.
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  setTimeout(() => {
    if (location.action === 'PUSH') {
      window.scrollTo(0, 0)
    } else {
      const savedPosition = getSavedScrollPosition(location)

      window.scrollTo(...(savedPosition || [0, 0]))
    }
  }, 10)

  return false
}
